import React from "react";
import styled from "styled-components";

const Splash = ({
  title,
  description,
  copyList,
  image,
  layout,
  direction = "center",
}) => {
  return (
    <Wrapper>
      <Image src={image} />
      <Title layout={layout} direction={direction}>
        <div>{title}</div>
        <Description layout={layout}>{description}</Description>
      </Title>
      <Reasons>{createList(copyList, layout)}</Reasons>
    </Wrapper>
  );
};
const createList = (list, layout) => {
  return list.map((obj, index) => {
    return (
      <Item key={index}>
        <Header layout={layout}>{obj.title}</Header>
        <Copy>{obj.copy}</Copy>
        {obj.link && (
          <Link>
            <a target="_blank" href={obj.link}>
              Link
            </a>
          </Link>
        )}
      </Item>
    );
  });
};
const Wrapper = styled.article`
  width: 100%;
  position: relative;
`;
const Image = styled.img`
  width: 100%;
  box-shadow: 1px 2px 2px 1px var(--asbestos);
`;
const Title = styled.h3`
  position: absolute;
  top: 2em;
  text-shadow: 1px 1px 1px var(--midnight-blue);
  color: ${(props) => {
    return {
      light: "var(--peter-river)",
      bright: "var(--alizarin)",
    }[props.layout];
  }};
  margin-left: ${(props) => (props.direction === "left" ? "1em;" : "0;")}
  font-size: xxx-large;
  font-family: var(--defaultFont);
  font-weight: bold;
  width: 100%;
  & > div,
  & > p {
    text-align: ${(props) => (props.direction === "left" ? "left" : "center")};
  }
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    top:1em;
      font-size: 5em;
      font-weight: bolder;
    }
`;

const Description = styled.p`
  font-size: x-large;
  color: ${(props) => {
    return {
      light: "var(--midnight-blue)",
      bright: "var(--white)",
    }[props.layout];
  }};
  margin: 2em;
  text-shadow: ${(props) => {
    return {
      light: "2px 2px 1px var(--clouds)",
      bright: "2px 2px 1px var(--wet-asphalt)",
    }[props.layout];
  }};
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    font-size: 0.5em;
    font-weight: bolder;
    width: ${(props) => {
      return {
        light: "60%",
        bright: "30%",
      }[props.layout];
    }};
    margin: ${(props) => {
      return {
        light: "1em auto",
        bright: "1em 0 0 .4em",
      }[props.layout];
    }};
  }
`;
const Reasons = styled.article`
  display: flex;
  margin: 5em 5em 0;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;
const Item = styled.div`
  width: 15em;
  height: 10em;
  margin-bottom: 5em;
  display: inline-block;
  vertical-align: top;
  padding: 2em 3em 5em;
  box-shadow: 4px 2px 10px var(--concrete);
  position: relative;
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    width: 25em;
    height: 25em;
  }
`;
const Header = styled.h4`
  box-shadow: 1px 2px 2px 1px var(--asbestos);
  border-radius: 10px;
  background-color: ${(props) => {
    return {
      light: "var(--pomegranate)",
      bright: "var(--carrot)",
    }[props.layout];
  }};
  color: white;
  width: fit-content;
  padding: 1em;
  margin: 0 auto 1em;
  font-weight: bolder;
  text-shadow: 2px 1px 1px var(--wet-asphalt);
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    font-size: x-large;
  }
`;
const Copy = styled.p`
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    font-size: x-large;
    font-weight: bolder;
  }
`;
const Link = styled.div`
  position: absolute;
  bottom: 1em;
  width: 100%;
  left: 0;
  & a {
    @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
      font-size: xx-large;
    }
  }
`;
export default Splash;
